import React from 'react';

import { useManagerPolicyContext } from '../../../contexts/ManagerPolicyContext';
import Loader from '../../ui/Loader';

export default function Wait() {
  const { state: policyState } = useManagerPolicyContext();

  return (
    <div className="ibox-content mt20">
      <Loader state={policyState.policy == null} />
    </div>
  );
}
